export const ORDER_FORECAST_BULK_TEMPLATE = '/static/Outbound_Forecast_Template-v2.xlsx';

export const HELPER_TEXT_UPLOAD_FILE = 'Upload details of Order Forecast';

export const OnHoldStatuses = ['on_hold', 'preorder', 'scheduled'];

export const FORECAST_STATUS = {
  UNDER_ESTIMATED: 'UNDER_ESTIMATED',
  OVER_ESTIMATED: 'OVER_ESTIMATED',
  CORRECTLY_ESTIMATED: 'CORRECTLY_ESTIMATED',
  NOT_ESTIMATED: 'NOT_ESTIMATED',
  ESTIMATED: 'ESTIMATED',
};

export const LEGEND_DESCRIPTION = {
  UNDER_ESTIMATED: 'Actual order volume is below 20% variance of forecast',
  OVER_ESTIMATED: 'Actual order volume is above 20% variance of forecast',
  CORRECTLY_ESTIMATED: 'Actual order volume is within 20% variance of forecast',
  NOT_ESTIMATED: 'Forecast is not updated yet',
  ESTIMATED: 'Forecast is updated',
};

export const LEGEND_COLORCODE = {
  UNDER_ESTIMATED: 'var(--color-bright-orange)',
  OVER_ESTIMATED: 'var(--color-bright-red)',
  CORRECTLY_ESTIMATED: '#50d860',
  NOT_ESTIMATED: '#A4AFAF',
  ESTIMATED: '#847BFF',
};

export const BULK_UPLOAD_STATUS = {
  QUEUED: 'QUEUED',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
};

export const Releasable_Statuses = ['ON_HOLD', 'PREORDER', 'SCHEDULED'];

export const FORECAST_NOTE =
  'If forecast is not provided or is inaccurate (> 20% variance), Locad will not be liable for any breaches in outbound SLA. Please consistently provide updated forecasts especially for planned campaigns or expected surges in volume.';

export const SLA_TIMELINE_STEPS_COUNT = 7;

export const SLA_TIMELINE_MAP = {
  1: 'created_at',
  2: 'released_at',
  3: 'picked_at',
  4: 'packed_at',
  5: 'ready_for_dispatch_at',
  6: 'dispatched_at',
  7: 'completed_at',
};

export const DEFAULT_TIMELINE_STEPS = [
  {
    id: 1,
    label: 'Order Created',
    date: '2025-01-21T14:47:32.283990+08:00',
    status: 'pending',
    description: 'Order was successfully created and payment confirmed',
  },
  {
    id: 2,
    label: 'Released',
    date: null,
    status: 'pending',
    description: 'Order released to warehouse for processing',
  },
  {
    id: 3,
    label: 'Picked',
    date: null,
    status: 'pending',
    description: 'Items are picked from the Warehouse Inventory',
  },
  { id: 4, label: 'Packed', date: null, status: 'pending', description: 'Items are packed for Shipment' },
  {
    id: 5,
    label: 'Ready for Dispatch',
    date: null,
    status: 'pending',
    description: 'Package ready for carrier pickup',
  },
  { id: 6, label: 'Dispatched', date: null, status: 'pending', description: 'Package handed over to carrier' },
  { id: 7, label: 'Completed', date: null, status: 'pending', description: 'Order delivered to customer' },
];

export const PRODUCT_LINKS_TOOLTIP_TEXT = {
  CATALOGUE_PRODUCT: 'Catalogue product SKU. Click to view product.',
  INVENTORY_PRODUCT: 'Inventory product SKU. Click to view product.',
};

export const ORDER_AGE_METRICS = [
  {
    label: '0-12hrs',
    value: `0-${12 * 60}`,
  },
  {
    label: '12-24hrs',
    value: `${12 * 60}-${24 * 60}`,
  },
  {
    label: '24-48hrs',
    value: `${24 * 60}-${48 * 60}`,
  },
  {
    label: '>48hrs',
    value: `${48 * 60}-`,
  },
];
